import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Progress,
  Row,
} from "reactstrap";
import { Fragment, useState } from "react";
import { H4 } from "../../AbstractElements";

const FormStepContainer = ({ step, children }) => {
  return (
    <Fragment>
      <Container fluid={true}>
        <Card>
          <CardHeader>
            <Row xs={children.length} className="text-center">
              {children.map((child, index) => (
                <Col>
                  <H4>Step {index + 1}</H4>
                </Col>
              ))}
            </Row>
            <Progress
              className="mt-3"
              color="primary"
              style={{
                height: "3px",
              }}
              value={((step + 1) / children.length) * 100}
            />
          </CardHeader>
          <CardBody>{children[step]}</CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};

export default FormStepContainer;
